/**
 * Ссылки подвала без реестра страниц: то, что можно импортировать из
 * клиентских шапки и подвала.
 *
 * `ais-podval.ts` разрешает адреса по реестру страниц инструментов, а
 * реестр несёт поля форм и промпты. Клиентский импорт оттуда увозил его
 * в JS каждой страницы, поэтому постоянные ссылки и типы живут здесь,
 * а группы инструментов шапка и подвал получают готовыми с сервера
 * (`gruppySoSsylkami`).
 */

/** Ссылка подвала: адрес и ключ подписи. */
export interface SsylkaPodvala {
  href: string;
  /** Ключ в словаре `ais_layout`. */
  klyuchPodpisi: string;
}

/** Группа подвала с уже разрешёнными адресами. */
export interface GruppaSoSsylkami {
  /** Ключ подписи в словаре `ais_layout`. */
  klyuchZagolovka: string;
  ssylki: SsylkaPodvala[];
}

/**
 * Колонка «Для бизнеса» (ingdg_com#187, правка владельца 27.09).
 *
 * Отдельно от групп инструментов: те же ссылки идут в пункт шапки, а
 * группы инструментов в шапке живут под кнопкой «Инструменты», и
 * бизнес-страницам там не место. Порядок задан владельцем.
 */
export const SSYLKI_BIZNESA: SsylkaPodvala[] = [
  { href: '/business', klyuchPodpisi: 'footer_biz_business' },
  { href: '/business/sayt', klyuchPodpisi: 'footer_biz_sayt' },
  { href: '/business/razrabotka', klyuchPodpisi: 'footer_biz_razrabotka' },
  { href: '/business/bezopasnost', klyuchPodpisi: 'footer_biz_bezopasnost' },
];

/**
 * Колонка «Программы» (02.10.2026): раздел нашего софта для компьютера.
 * Только русская витрина, как и колонка бизнеса.
 */
/**
 * Программы на aisearch.tech (04.10.2026, просьба владельца): раньше
 * колонка была только на .ru, и с .tech на Конспект не вело ни одной
 * ссылки. Диктовка есть на en и es, на sr страницы нет — `jazyki`.
 */
export const SSYLKI_PROGRAMM_TECH: (SsylkaPodvala & { jazyki?: readonly string[] })[] = [
  { href: '/programs', klyuchPodpisi: 'footer_prog_vse' },
  { href: '/programs/konspekt', klyuchPodpisi: 'footer_prog_konspekt' },
  { href: '/programs/dictation', klyuchPodpisi: 'footer_prog_golos', jazyki: ['en', 'es'] },
];

export const SSYLKI_PROGRAMM: SsylkaPodvala[] = [
  { href: '/programmy', klyuchPodpisi: 'footer_prog_vse' },
  { href: '/programmy/konspekt', klyuchPodpisi: 'footer_prog_konspekt' },
  { href: '/programmy/golosovoy-vvod', klyuchPodpisi: 'footer_prog_golos' },
];
